function createCanvasItem(opt) {
  let canvas = document.createElement('canvas')
  canvas.width = opt.itemWidth
  canvas.height = opt.itemHeight
  let ctx = canvas.getContext('2d')

  ctx!.font = `${opt.fontSize}px sans-serif`
  ctx!.fillStyle = opt.color
  ctx!.globalAlpha = opt.opacity

  const textWidth = Math.ceil(ctx!.measureText(opt.text).width)
  let x = (opt.itemWidth - textWidth) / 2
  let y = (opt.itemHeight + 20) / 2

  ctx!.translate(opt.itemWidth / 2, opt.itemHeight / 2)
  ctx!.rotate((-opt.angle * Math.PI) / 180)
  ctx!.translate(-opt.itemWidth / 2, -opt.itemHeight / 2)
  ctx!.fillText(opt.text, x, y)

  return canvas
}

export function createWatermark(params): Promise<any> {
  return new Promise((resolve, reject) => {
    let defaultOpt = {
      type: 'right-bottom',
      fontSize: '14',
      color: '#ffffff',
      opacity: 1,
      angle: 0,
      itemWidth: 100,
      itemHeight: 100,
      text: ''
    }

    let opt = Object.assign(defaultOpt, params)
    const image = new Image()
    image.crossOrigin = 'anonymous' // 解决跨域问题，配合服务端设置
    image.src = opt.src

    const loadFn = (e) => {
      const width = image.width
      const height = image.height

      const canvas1 = document.createElement('canvas')
      const ctx1 = canvas1.getContext('2d')
      canvas1.width = width
      canvas1.height = height

      const canvas2 = document.createElement('canvas')
      const ctx2 = canvas2.getContext('2d')
      canvas2.width = width
      canvas2.height = height

      ctx2!.font = `${opt.fontSize}px sans-serif`
      ctx2!.fillStyle = opt.color
      ctx2!.globalAlpha = opt.opacity
      const textWidth = Math.ceil(ctx2!.measureText(opt.text).width)

      // 判断水印类型
      switch (opt.type) {
        case 'repeat':
          let canvasBackground = createCanvasItem(opt)
          let patten = ctx2!.createPattern(canvasBackground, 'repeat')
          ctx2!.fillStyle = patten!
          ctx2!.fillRect(0, 0, width, height)
          break
        case 'left-top':
          ctx2!.fillText(opt.text, 10, 10 + opt.fontSize)
          break
        case 'right-top':
          ctx2!.fillText(opt.text, width - 10 - textWidth, 10 + opt.fontSize)
          break
        case 'center-top':
          ctx2!.fillText(opt.text, (width - textWidth) / 2, 10 + opt.fontSize)
          break
        case 'left-bottom':
          ctx2!.fillText(opt.text, 10, height - 10)
          break
        case 'right-bottom':
          ctx2!.fillText(opt.text, width - 10 - textWidth, height - 10)
          break
        case 'center-bottom':
          ctx2!.fillText(opt.text, (width - textWidth) / 2, height - 10)
          break
        default:
          break
      }

      ctx1!.clearRect(0, 0, width, height)
      ctx1!.drawImage(image, 0, 0, width, height)
      ctx1!.drawImage(canvas2, 0, 0, width, height)

      const dataUrl = canvas1.toDataURL()
      resolve(dataUrl)
      image.removeEventListener('load', loadFn)
    }

    const errorFn = (e) => {
      reject(e)
      image.removeEventListener('error', errorFn)
    }

    image.addEventListener('load', loadFn)
    image.addEventListener('error', errorFn)
  })
}
